import { Flex, Typography, Alert } from "antd"
import SvgIcons from "../layout/assets/SvgIcons"
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setSelectedWidget } from "../../redux/slices/widgetsSlice";
import { resolveFieldTranslation } from "../../utils/formTranslations";
const { Title } = Typography;

const FormHeader = (props) => {
    const { headerData = {}, formType, currentStep={}, spaceData={} } = props
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    // Resolve header text for the active app locale; editing always targets the
    // canonical (default-language) header data via `headerData`.
    const localized = resolveFieldTranslation(headerData, i18n.language)
    const { label, description, secondaryText, info, formInfo } = localized

    const handleHeaderClick = () => {
        // Pass the full header (including `translations`) so the config panel can
        // edit per-language text without losing existing translations.
        dispatch(setSelectedWidget({ ...headerData, formType: "header" }))
    }

    return (
        <Flex vertical align="center" className={`${formType === "header" ? "selected-header" : ""} form-header `} onClick={handleHeaderClick}>
            <Flex style={{ width: "100%" }} gap="1rem">
                <span style={{ color: spaceData?.spaceColor || "#faad14", display: "flex" }}>

                <SvgIcons type={spaceData?.spaceIcon || ""} />
                </span>
                <Flex gap={8} vertical style={{ flexGrow: "1" }}>
                    <Title level={4} style={{ margin: "0" }}>{label || "Intake Form"}</Title>
                    {
                        secondaryText && description && <div className="text-regular">{description}</div>
                    }
                    {
                        info && <Alert message={formInfo} type="info" showIcon />
                    }

                </Flex>

            </Flex>
        </Flex>
    )
}

export default FormHeader
